'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
var Grid = _interopDefault(require('@material-ui/core/Grid'));
var styledComponents = require('./styled-components.js');

var Description = function (props) {
    var description = props.description;
    if (!description) {
        return null;
    }
    if (typeof description === 'string') {
        return (React__default.createElement(styledComponents.StyledDescription, { "data-testid": 'review-card-description' }, description));
    }
    return description;
};
var ReviewCard = function (props) {
    var title = props.title, StatComponent = props.StatComponent, description = props.description;
    return (React__default.createElement(styledComponents.SizedCard, null,
        React__default.createElement(styledComponents.StyledCardContent, null,
            React__default.createElement(styledComponents.Title, { "data-testid": 'review-card-title' }, title),
            React__default.createElement(Grid, { container: true, alignItems: 'flex-start' },
                React__default.createElement(Grid, { item: true },
                    React__default.createElement(styledComponents.Statistic, null,
                        React__default.createElement(StatComponent, null)),
                    React__default.createElement(Description, { description: description }))))));
};

module.exports = ReviewCard;
